import {twMerge} from '../common/twMerge';
import {StaticImage} from '../design-system/atoms/StaticImage/StaticImage';
import {StaticImageType} from '../design-system/atoms/StaticImage/StaticImageType.enum';
import {ErrorArea} from '../design-system/organisms/ErrorArea/ErrorArea';
import {PC_HEADER_HEIGHT} from '../design-system/organisms/PcHeader/constants';
import {MOBILE_HEADER_HEIGHT_PX} from '../header/constants';

export function CmsPreviewError({isMobile}: {isMobile: boolean}) {
  return (
    <>
      <div
        className="flex items-center w-full"
        style={
          isMobile
            ? {
                height: MOBILE_HEADER_HEIGHT_PX,
                paddingLeft: 15,
                paddingTop: 19,
              }
            : {height: PC_HEADER_HEIGHT, paddingLeft: 30}
        }
      >
        <StaticImage imageType={StaticImageType.LogoBiTextL} />
      </div>
      <ErrorArea isMobile={isMobile} isDesignFree={true}>
        <ErrorArea.Image
          type={StaticImageType.ExceptionNoticeLStatic}
        ></ErrorArea.Image>
        <ErrorArea.Title className="font-large3-bold mt-32pxr text-theme-solid-100">
          요청하신 페이지에 접근할 수 없습니다.
        </ErrorArea.Title>
        <ErrorArea.MainText
          className={twMerge(
            'font-small1 mt-16pxr break-words text-theme-solid-60',
            !isMobile && 'max-w-360pxr'
          )}
        >
          {isMobile
            ? '카카오 페이지 보안 정책에 따라 미리보기\n 화면은 파트너 사이트와 EXID를 통해서만\n 진입이 가능합니다.'
            : '카카오 페이지 보안 정책에 따라 미리보기 화면은\n 파트너 사이트와 EXID를 통해서만 진입이 가능합니다.'}
        </ErrorArea.MainText>
      </ErrorArea>
    </>
  );
}
